module.exports = __webpack_public_path__ + "media/images/globe-1f9dfd7c4dc7fe71fe878664f7760b05.png";